import { render, staticRenderFns } from "./ReportFormer.vue?vue&type=template&id=7ca85748&scoped=true&"
import script from "./ReportFormer.vue?vue&type=script&lang=js&"
export * from "./ReportFormer.vue?vue&type=script&lang=js&"
import style0 from "./ReportFormer.vue?vue&type=style&index=0&id=7ca85748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca85748",
  null
  
)

export default component.exports